import { Box } from "@mui/material";
import React from "react";
import { allowedToUpdateEntity } from "src/constants/role";
import { dataStateType } from "src/constants/status";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useAuth from "src/hooks/useAuth";
import { releaseGroupColumns as columns } from "../../Helper";
import { Link } from "react-router-dom";
import { path } from "src/constants/path";

const GetReleaseGroupColumns = ({ limit, page, status }) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();

  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <Link
            to={{
              pathname: `${path.releaseGroup}/edit/${item.id}`,
              state: { page, limit },
            }}
          >
            <button className="btn btn-warning">
              <i className="bx bx-edit"></i>
            </button>
          </Link>
        )}
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, actionCol];
  }

  return columns;
};

export default GetReleaseGroupColumns;
